import { createContext } from 'react';
import { SelectionContextValue } from 'src/components/DataTable/types/DataTableSelection';

export const DataTableSelectionContext =
  createContext<SelectionContextValue | null>(null);
